document.addEventListener("DOMContentLoaded", function () {
  const section = document.getElementById("buy-by-team");
  if (!section) return;

  const tabContainer = section.querySelector(".dynamic-tabs__tab-list");
  if (!tabContainer) return;

  const tabs = Array.from(tabContainer.querySelectorAll(".dynamic-tabs__tab"));
  const contents = Array.from(section.querySelectorAll(".tab-content"));

  let activeTab = tabContainer.querySelector(".dynamic-tabs__tab.active") || tabs[0];

  function activateTab(clickedTab) {
    if (!clickedTab || clickedTab === activeTab) return;

    const tabId = clickedTab.getAttribute("data-tab");
    if (!tabId) return;

    if (activeTab) {
      activeTab.classList.remove("active");
      activeTab.setAttribute("data-state", "inactive");
      activeTab.setAttribute("aria-selected", "false");
    }

    clickedTab.classList.add("active");
    clickedTab.setAttribute("data-state", "active");
    clickedTab.setAttribute("aria-selected", "true");

    activeTab = clickedTab;

    contents.forEach(function (content) {
      const isTarget = content.getAttribute("data-tab") === tabId;

      content.classList.toggle("active", isTarget);
      content.hidden = !isTarget;

      if (isTarget) {
        const lazyImages = content.querySelectorAll("img[loading='lazy']");

        lazyImages.forEach(function (img) {
          if (!img.dataset.lazyBound) {
            img.dataset.lazyBound = "1";
            img.loading = "eager";
            img.fetchPriority = "auto";
          }
        });
      }
    });
  }

  tabContainer.addEventListener("click", function (event) {
    const clickedTab = event.target.closest(".dynamic-tabs__tab");
    if (!clickedTab) return;

    activateTab(clickedTab);
  });

  tabContainer.addEventListener("keydown", function (event) {
    const currentIndex = tabs.indexOf(activeTab);
    if (currentIndex === -1) return;

    let nextIndex = null;

    if (event.key === "ArrowLeft") {
      nextIndex = Math.min(currentIndex + 1, tabs.length - 1);
    }

    if (event.key === "ArrowRight") {
      nextIndex = Math.max(currentIndex - 1, 0);
    }

    if (event.key === "Home") {
      nextIndex = 0;
    }

    if (event.key === "End") {
      nextIndex = tabs.length - 1;
    }

    if (nextIndex === null || !tabs[nextIndex]) return;

    event.preventDefault();
    tabs[nextIndex].focus();
    activateTab(tabs[nextIndex]);
  });
});